import { useEffect, useState } from "react";
import useActions from "../../../hooks/service-actions.hook";
import { useEntity } from "../../../hooks/use-entity.hook";
import useUserDetails from "../../../hooks/user-details.hook";
import UsersInUseModal from "../../Common/users-in-use-modal/users-in-use.modal";
import { useAuth } from "../../context/Auth";
import MembersPageLoader from "../../settingsV2/members/MembersPageLoader";
import HeaderWithAddButton from "../Components/HeaderWithAddButton";
import MspMemberAccessRoleModal from "./Components/MspMemberAccessRoleModal";
import RolesBlock from "../Components/RolesBlock";
import MembersBlock from "./Components/MembersBlock";
import { getAPIData, postRequest } from "../../../Utils/commonApi";
import { CallToast } from "../../PriceCalculator/modals/CustomToast";
import { getAccessStateValue } from "../../App/App";
import { Entities } from "../../../common/store/entities/entities.enum";
import { MemberDetailsEffectActions } from "../../../common/services/member-details/member-details.service";
import { AccessRolesDetailsEffectActions } from "../../../common/services/access-roles-details/access-roles-details.service";
import "./membersAccess.scss";
import '../mspMembersAccess.scss';
import AddMemberModalOuter from "../../Common/AddMemberModal";
import { API_DOMENS } from "../../../constants/apis.constants";

const RoleAction = {
  Duplicate: 0,
  Delete: 1,
}

const MembersAccessPage = ({ isView = false }) => {
  const { clientId } = useUserDetails();
  const { getMemberDetails } = useActions(MemberDetailsEffectActions);
  const { getAccessRolesDetails } = useActions(AccessRolesDetailsEffectActions);
  const { entityData: memberDetails } = useEntity({ entityType: Entities.MemberDetails, entityId: clientId });
  const { entityData: accessRolesDetails } = useEntity({ entityType: Entities.AccessRolesDetails, entityId: clientId });

  const { authTokens } = useAuth();
  const [members, setMembers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [accessLevelId, setAccessLevelId] = useState(0);
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const [pageStatus, setPageStatus] = useState("Members");
  const [mainPageLoading, setMainPageLoading] = useState(false);
  const [showAccessLevelModal, setShowAccessLevelModal] = useState(false);
  const [updatingRoleLoading, setUpdatingRoleLoading] = useState({
    roleId: null,
    action: null
  });
  const [usersInUseData, setUsersInUseData] = useState(null);
  const [tooltipMessage, setTooltipMessage] = useState(null);
  const [isAdminConfirmed, setIsAdminConfirmed] = useState(false);
  const [dontAllowEdit, setDontAllowEdit] = useState(false);

  useEffect(() => {
    setMainPageLoading(true);
    getMembersDetails();
    getAccessRolesData();
  }, []);

  async function changeMemberRole(roleId, userId, roleAction) {
    await postRequest(authTokens, "UpdateUserAccessRole", {
      objId_AccessRole: roleId,
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      userId: userId,
      action: roleAction,
      optionEnum99: 5,
    }, API_DOMENS.CC_API)
      .then((response) => {
        if (response?.Success) {
          CallToast("Access role changed successfully", false, false, "v2style");
          getMembersDetails();
          getAccessRolesData();
        } else {
          CallToast("Something went wrong", false, false, "v2style");
        }
      })
      .catch(() => {
        CallToast("Something went wrong", false, false, "v2style");
      });
  }

  async function getAccessRolesData() {
    getAccessRolesDetails({ clientId, kwargs: { optionEnum1: 0 } });
  }

  async function getMembersDetails(openTeamModal = null) {
    getMemberDetails({ clientId });
  }

  async function duplicateRole(roleId) {
    setUpdatingRoleLoading({ roleId: roleId, action: RoleAction.Duplicate });
    await getAPIData(577, authTokens, {
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      optionEnum1: roleId,
      optionEnum99: 5,
    }, API_DOMENS.CC_API).then((response) => {
      setUpdatingRoleLoading({ roleId: null, action: null });
      setMainPageLoading(false);
      if (response.Success) {
        getAccessRolesData();
      }
    });
  }

  async function deleteRole(roleID) {
    setUpdatingRoleLoading({ roleId: roleID, action: RoleAction.Delete });
    await getAPIData(578, authTokens, {
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      optionEnum1: roleID,
      optionEnum99: 5,
    }, API_DOMENS.CC_API).then((response) => {
      setMainPageLoading(false);
      setUpdatingRoleLoading({ roleId: null, action: null });
      if (response?.mr?.Success) {
        getAccessRolesData();
        CallToast(response?.mr?.Message, false, false, "v2style");
      } else {
        if (response?.detail?.users) {
          setUsersInUseData(response?.detail);
        } else {
          if (response?.EntityId == -1) {
            CallToast(response?.Message, false, false, "v2style");
          } else {
            CallToast("Something went wrong", false, false, "v2style");
          }
        }
      }
    });
  }

  async function handleDeleteUser(userId) {
    await getAPIData("570", authTokens, {
      optionEnum1: userId,
      optionEnum99: 5,
    }, API_DOMENS.CC_API).then((response) => {
      if (response.Success) {
        getMembersDetails();
        CallToast("Member deleted successfully", false, false, "v2style");
      } else {
        CallToast("Something went wrong", false, false, "v2style");
      }
    });
  }

  useEffect(() => {
    if (!memberDetails) return;
    setMembers(memberDetails?.users);
    setIsAdminConfirmed(memberDetails?.isAdminConfirmed);
    setTooltipMessage(memberDetails?.notConfirmedMessage);
  }, [memberDetails])

  useEffect(() => {
    if (!accessRolesDetails) return;
    setRoles(accessRolesDetails);
  }, [accessRolesDetails])

  return (
    <div className={`${""}`}>
      {!accessRolesDetails || !memberDetails ? <MembersPageLoader /> :

        <div className="membersAccess-wrapper bottomMarginUserRoleBlocks">
          <div className="heading mb-24px">Members</div>
          <HeaderWithAddButton
            children={<div className="align-items-center d-flex pointer" style={{ gap: "12px" }}>
              <div className={pageStatus === "Members" ? "txt-blue" : "f-grey"} onClick={() => { setPageStatus("Members"); }}>
                Members
              </div>
              <div className="px-2 rounded-full d-flex align-items-center f-grey bg-darkgrey f-8 f-500 pointer" style={{ height: "20px" }}>
                {members.length}
              </div>
              <div className={pageStatus === "Members" ? "f-grey" : "txt-blue"} onClick={() => { setPageStatus("Access Roles"); }}>
                Access Roles
              </div>
            </div>
            }
            isTooltipDisabled={isAdminConfirmed}
            tooltipText={"You must verify your account before you can add users."}
            buttonLabel={`Add ${pageStatus}`}
            isDisable={isView || getAccessStateValue("AccessState_MSP_User_Management") < 3}
            onButtonClick={() => {
              if (isView) return;
              console.log("pageStatus", pageStatus);
              if (pageStatus === "Members") {
                setShowAddMemberModal(false);
                setTimeout(() => { setShowAddMemberModal(true); }, 100);
              } else {
                setShowAccessLevelModal(true);
                getAccessRolesData();
                setAccessLevelId(0);
              }
            }}
          />

          {pageStatus === "Members" ?
            <MembersBlock
              data={members}
              rolesData={roles}
              isDisable={isView || getAccessStateValue("AccessState_MSP_User_Management") < 3}
              setShowAccessLevelModal={setShowAccessLevelModal}
              onRoleItemClick={(memb, roleItem) => {
                if (isView) return;
                const memberRolesArray = memb?.objId_AccessRole?.split(",")?.map(Number);
                let action;
                if (memberRolesArray) {
                  const isRoleHere = memberRolesArray?.find((item) => item === roleItem.objId_AccessRole);
                  action = isRoleHere === roleItem.objId_AccessRole ? 0 : 1;
                } else {
                  action = 1;
                }
                if (memb?.IsLoggedInUser === true && memb?.SO_Admin === true) {
                  if (memberRolesArray.length === 1 && action === 0) {
                    CallToast("Member role can not be empty", false, false, "v2style");
                  }
                } else {
                  changeMemberRole(roleItem.objId_AccessRole, memb.userId, action);
                }
              }}
              onDeleteClick={(id) => {
                if (isView) return;
                handleDeleteUser(id);
              }}
            />
            :
            <RolesBlock
              isView={isView}
              data={roles}
              updatingRoleLoading={updatingRoleLoading}
              onItemClick={(item) => {
                if (isView) return;
                if (item?.IsDefault === 1) {
                  setDontAllowEdit(true);
                }
                setAccessLevelId(item?.objId_AccessRole);
                setShowAccessLevelModal(true);
              }}
              onDuplicateRole={(roleId) => {
                if (isView) return;
                duplicateRole(roleId);
              }}
              onDeleteRole={(roleID) => {
                if (isView) return;
                deleteRole(roleID);
              }}
              onAccessLevelRole={(item) => {
                if (isView) return;
                setAccessLevelId(item?.objId_AccessRole);
                setShowAccessLevelModal(true);
              }}
            />
          }
          <AddMemberModalOuter
            show={showAddMemberModal}
            hideModal={() => {
              setShowAddMemberModal(false);
            }}
            isForMSP={true}
            refreshData={() => {
              setMainPageLoading(true);
              getMembersDetails();
            }}
          />
          <MspMemberAccessRoleModal
            accessLevelId={accessLevelId}
            show={showAccessLevelModal}
            hideModal={() => {
              setDontAllowEdit(false);
              setShowAccessLevelModal(false);
            }}
            parentID="msp-main-screen-for-integration-modal"
            passedOptionEnum99={5}
            dontAllowEdit={dontAllowEdit}
            refreshData={() => {
              setDontAllowEdit(false);
              setMainPageLoading(true);
              getAccessRolesData();
            }}
            setUsersInUseData={setUsersInUseData}
          />
          <UsersInUseModal
            show={usersInUseData !== null}
            onHide={() => setUsersInUseData(null)}
            data={usersInUseData}
            title="Access Role in use"
          />

        </div>

      }
    </div >
  );
};

export default MembersAccessPage;
